export default "/images/shield.png?226b0ee7cc0e1ad827c781c5831c6405";